import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';
import { TableColumn } from '@shared/components/molecules/ui-molecule-mat-table/interfaces/table-column';
import { UiAtomButtonComponent } from '../../atoms/ui-atom-button/ui-atom-button.component';
import { UiAtomSensitiveBadgeComponent } from '../../atoms/ui-atom-sensitive-badge/ui-atom-sensitive-badge.component';

export interface ExportColumnsDialogData {
  columns: TableColumn[];
  /** Permite confirmar sin ninguna columna seleccionada (ej. PDF anónimo). */
  allowEmpty?: boolean;
  /** Overrides i18n opcionales (por defecto, textos de exportColumns.dialog). */
  titleKey?: string;
  subtitleKey?: string;
  emptyHintKey?: string;
  /** Nota informativa opcional, siempre visible bajo la lista de columnas. */
  noteKey?: string;
}

@Component({
  selector: 'ui-molecule-dialog-export-columns',
  standalone: true,
  imports: [
    MatCheckboxModule,
    MatDividerModule,
    MatIconModule,
    TranslatePipe,
    UiAtomButtonComponent,
    UiAtomSensitiveBadgeComponent,
  ],
  templateUrl: './ui-molecule-dialog-export-columns.component.html',
  styleUrl: './ui-molecule-dialog-export-columns.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMoleculeDialogExportColumnsComponent {
  protected selectedKeys: Set<string>;

  constructor(
    private dialogRef: MatDialogRef<UiMoleculeDialogExportColumnsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExportColumnsDialogData,
  ) {
    this.selectedKeys = new Set(
      data.columns.filter((c) => !c.sensitive && !c.excludeFromDefaultExport).map((c) => c.key),
    );
  }

  protected get allSelected(): boolean {
    return this.selectedKeys.size === this.data.columns.length;
  }

  protected get someSelected(): boolean {
    return this.selectedKeys.size > 0 && this.selectedKeys.size < this.data.columns.length;
  }

  protected toggleAll(checked: boolean): void {
    if (checked) {
      this.data.columns.forEach((c) => this.selectedKeys.add(c.key));
    } else {
      this.selectedKeys.clear();
    }
  }

  protected toggle(key: string, checked: boolean): void {
    if (checked) {
      this.selectedKeys.add(key);
    } else {
      this.selectedKeys.delete(key);
    }
  }

  protected onCancel(): void {
    this.dialogRef.close(null);
  }

  protected onContinue(): void {
    this.dialogRef.close([...this.selectedKeys]);
  }
}
